/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, type FC, useEffect } from 'react'
import { viewGatewayService } from '../../services/viewGatewayService'
import { MemoWraperHierarchy } from '../../../common/WraperHierarchy'

interface ViwGateway {
  loading: boolean
  ViewGateway: any
  errorMsg: boolean
}

const ViewGateway: FC<any> = (props) => {
  const [gatewayView, setgatewayView] = useState<ViwGateway>({
    loading: false,
    ViewGateway: {},
    errorMsg: false
  })

  useEffect(() => {
    viewGatewayData()
  }, [props.gatewayId])

  const viewGatewayData = (): any => {
    viewGatewayService.viewGateway(props.gatewayId, props.assetId)
      .then((res: any) => {
        setgatewayView({ ...gatewayView, ViewGateway: res.data.data })
      })
      .catch(
        (res: any) => {
        }
      )
  }

  const { ViewGateway } = gatewayView

  return (
    <MemoWraperHierarchy
      site={ViewGateway?.hierarchyStructure?.site}
      id={props.gatewayId}
      handleClose={() => { props.viewGatewayPopup(false) }}
      viewPopup={() => { props.viewGatewayPopup('') }} />

  )
}

export default ViewGateway
